class Klarna {
    constructor() {
        this.klarna = window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    }

    refreshPlacements() {
        return new Promise(async(resolve, reject) => {
            try {
                await this.klarna.push({ eventName: 'refresh-placements' });

                resolve();
            } catch (error) {
                reject(error);
            }
        })
    }

    loaded() {
        try {
            return this.klarna.loaded;
        } catch (error) {
            console.log(error)
        }
    }
}

export default new Klarna()
